"use strict";
/**
 * AngularJS icon service.
 *
 * @packageDocumentation
 * @module Icon
 */
Object.defineProperty(exports, "__esModule", { value: true });
var icon_interfaces_1 = require("./icon.interfaces");
exports.SERVICE_NAME = 'imr.controls.services.icon';
exports.PROVIDER_NAME = 'imr.controls.services.provider.icon';
/**
 * Creates an icon configuration.
 *
 * @category Service
 */
var IMRIconService = /** @class */ (function () {
    function IMRIconService() {
    }
    IMRIconService.prototype.createIcon = function (iconName, provider) {
        return new icon_interfaces_1.IMRIconConfiguration(iconName, provider);
    };
    return IMRIconService;
}());
exports.IMRIconService = IMRIconService;
/**
 * A provider for {@link IMRIconService}
 *
 * @category Provider
 */
var IMRIconServiceProvider = /** @class */ (function () {
    function IMRIconServiceProvider() {
        //#region IServiceProvider Implementation
        this.$get = [function () {
                return new IMRIconService();
            }];
        //#endregion
    }
    /**
     * {@link IMRIconService.createIcon}
     */
    IMRIconServiceProvider.prototype.createIcon = function (iconName, provider) {
        return new icon_interfaces_1.IMRIconConfiguration(iconName, provider);
    };
    return IMRIconServiceProvider;
}());
exports.IMRIconServiceProvider = IMRIconServiceProvider;
//# sourceMappingURL=icon.service.js.map